/**
 * Select Date Step
 */

import React from 'react';
import { addDays, addHours, startOfToday } from 'date-fns';
import { CalendarPicker } from '@/components/booking';

interface SelectDateStepProps {
  selectedDate: Date | undefined;
  onSelectDate: (date: Date | undefined) => void;
  availableDates: string[];
  currentMonth: Date;
  onMonthChange: (date: Date) => void;
  loading: boolean;
  advanceBookingMinHours?: number;
  advanceBookingMaxDays?: number;
}

export const SelectDateStep: React.FC<SelectDateStepProps> = ({
  selectedDate,
  onSelectDate,
  availableDates,
  currentMonth,
  onMonthChange,
  loading,
  advanceBookingMinHours = 0,
  advanceBookingMaxDays,
}) => {
  return (
    <div>
      <h2 className='mb-1 text-2xl font-bold text-slate-900'>Select a Date</h2>
      <p className='mb-6 text-sm text-slate-500'>Choose an available date for your appointment</p>

      <CalendarPicker
        selectedDate={selectedDate}
        onSelectDate={onSelectDate}
        availableDates={availableDates}
        currentMonth={currentMonth}
        onMonthChange={onMonthChange}
        loading={loading}
        // minDate={addHours(new Date(), advanceBookingMinHours || 1)}
        maxDate={advanceBookingMaxDays ? addDays(startOfToday(), advanceBookingMaxDays) : undefined}
      />
    </div>
  );
};
